const initialState = {
    a:23,
    data: undefined,
    selectors: [],

    options: {
      rowSelector: false,
    },
    meta: {
      page:0,
      size:25,
      total:undefined,
      refresh: false,
      loading: false,
    }
  }


  function isSelected(state,index){
    // check if already in list.
    for (var i=0;i<state.selectors.length;i++){
        if (state.selectors[i]== index){
            return true;
        }
    }
  }

  function removeSelected(state,index){
        
    let found = undefined;
    for (var i =0 ;i <state.selectors.length;i++){
        if (state.selectors[i] == index){
            found=i;
            break;
        }
    }

    if(!found && found !=0){
        return;
    }

    let l = state.selectors.slice(0,found);
    let r = undefined;
    if (found<state.selectors.length-1){
        r = state.selectors.slice(found+1);
    }
    let final = [];
    if (!r){
        final = l;
    }else{
        final= l.concat(r);
    }
    state.selectors = final;
  }
  
  export default function filtersReducer(state = initialState, action) {
    switch (action.type) {
      case 'ctable-update': {
        //  ;
        let s = {...state};
        s.data= action.data;

        // change selectors if needed.
        if (s.options.rowSelector){
          s.selectors =[];
        }

        s.meta.loading= false;
        return s;
      }
      case 'ctable-property-update':{
        let s = {...state};
        s.options = action.options;
        return s;
      }
      case 'ctable-toggle-selected-all':{
        let s = {...state};
        if (s.selectors.length == s.data.length){
          s.selectors=[];
        }else{
          let a =[];
          for (var i=0;i<s.data.length;i++){
              a.push(i);
          }
          s.selectors=a;
        }
    
        return s;
      }
      case 'ctable-toggle-selected':{
        let s = {...state};
        // already in list remove the entry
        if (isSelected(s,action.index)){
          removeSelected(s,action.index);

        }else{
            // not already in list.
            s.selectors =s.selectors.concat([action.index]);
        }
      
        return s;
      }
      case 'ctable-page-size':{
        let s = {...state};

        s.meta.size = action.data;
        return s;
      }
      case 'ctable-page-no':{
        let s = {...state};

        s.meta.page = action.data;
        return s;
      }
      case 'ctable-meta-total':{
        let s = {...state};

        s.meta.total = action.data;
        return s;
      }
      case 'ctable-meta-refresh-trigger':{
        let s = {...state};

        s.meta.refresh = !s.meta.refresh;
        return s;
      }
      case 'ctable-meta-refresh-done':{
        let s = {...state};

        s.meta.refresh = false;
        return s;
      }
      case 'ctable-meta-loading':{
        let s = {...state};

        s.meta.loading = true;
        return s;
      }
      case 'ctable-meta-loaded':{
        let s = {...state};

        s.meta.loading = false;
        return s;
      }

      default:
        return state
    }
  }